<template>
  <LeadLink
    v-if="callTarget != null"
    in-new-tab
    :call-target-id="callTarget.id"
    class="lead-link"
  >
    <div class="company-name">
      {{ callTarget.companyName || $t('general.none') }}
    </div>
    <div class="full-name">
      {{ callTarget.fullName || $t('general.none') }}
    </div>
  </LeadLink>
  <span v-else>
    {{ $t('general.none') }}
  </span>
</template>

<script lang="ts" setup>
import type { CallTargetMinimum } from '@/api/openapi';
import LeadLink from '../general/LeadLink.vue';

type TProps = {
  callTarget?: CallTargetMinimum;
};

defineProps<TProps>();
</script>

<style lang="scss" scoped>
.company-name {
  padding-bottom: $basespace-50;
}
.company-name, .full-name {
  @include m-truncate-text;
}
</style>
